import React, { useEffect } from "react";

export const ErrorFocus = ({ formik }) => {
    useEffect(() => {
        const { isSubmitting, isValidating, errors } = formik;
        const keys = Object.keys(errors);
        if (keys.length > 0 && isSubmitting && !isValidating) {
            let selector = "";
            const arrayField = errors[keys[0]];
            if (Array.isArray(arrayField)) {
                const errorIndex = arrayField.findIndex(item => item);
                const arrayFieldKeys = Object.keys(arrayField[errorIndex]);
                selector = `[name="${keys[0]}.${errorIndex}.${arrayFieldKeys[0]}"]`;
            } else {
                selector = `[name="${keys[0]}"]`;
            }
            const errorElement = document.querySelector(selector);
            if (errorElement) {
                errorElement.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest"
                });
            }
        }
    }, [formik]);
    return null;
};
